import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-epb-sosudov',
  templateUrl: './epb-sosudov.component.html',
  styleUrls: ['./epb-sosudov.component.scss']
})
export class EpbSosudovComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
